// extracted by mini-css-extract-plugin
export var grayShape = "y2fSo";
export var peachShape = "k0hch";
export var root = "Tw-69";
export var whiteBackground = "l5Iem";